import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import CodeWindow from "./CodeWindow";

const schema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    div: [...(defaultSchema.attributes?.div || []), ["className"]],
    span: [...(defaultSchema.attributes?.span || []), ["className"]],
    code: [...(defaultSchema.attributes?.code || []), ["className"]],
  },
};

export default function PostBody({ markdown }: { markdown: string }) {
  const fixed = (markdown ?? "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/\r\n/g, "\n");

  return (
    <div className="prose xl-sheet max-w-none font-ui">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[
          rehypeRaw,
          [rehypeSanitize, schema],
        ]}
      components={{
        code: ({ inline, className, children, ...props }: any) => {
          const text = String(children ?? "");
          const hasLang = /(^|\s)language-/.test(className || "");
          // Treat as a block window ONLY if:
          // - it's not inline, and
          // - it either has a language (```sql) OR contains a newline
          const isBlock = !inline && (hasLang || /\n/.test(text));

          if (!isBlock) {
            // Inline code (e.g., `<code>102</code>`) stays inline
            return (
              <code
                className={`px-1.5 py-0.5 rounded border border-gray-200 bg-[#F4F6F8] ${className || ""}`}
                {...props}
              >
                {children}
              </code>
            );
          }

          const lang = (className || "").replace("language-", "").trim() || "text";
          return <CodeWindow code={text.replace(/\n$/, "")} lang={lang} />;
        },
      }}
      >
        {fixed}
      </ReactMarkdown>
    </div>
  );
}